import client from './client';
import { Payment } from '../types/entities';
import { ApiResponse, CreatePaymentRequest } from '../types/api';

export const paymentAPI = {
  getByTrip: async (tripId: number): Promise<Payment[]> => {
    const response = await client.get(`/trips/${tripId}/payments`);
    return response.data.data;
  },

  create: async (tripId: number, data: Omit<CreatePaymentRequest, 'tripId'>): Promise<Payment> => {
    const response = await client.post(`/trips/${tripId}/payments`, data);
    return response.data.data;
  },

  update: async (id: number, data: Partial<CreatePaymentRequest>): Promise<Payment> => {
    const response = await client.put(`/payments/${id}`, data);
    return response.data.data;
  },

  delete: async (id: number): Promise<ApiResponse<null>> => {
    const response = await client.delete(`/payments/${id}`);
    return response.data;
  },
};
